module.exports = __webpack_public_path__ + "img/a0309_2.576948f4.png";